import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {Form, Col, Row, Divider, Transfer, Button, DatePicker, Modal} from "antd";
import {NewTitleTransferTaxStates} from "./types/NewTitleTransferTaxTypes";
import {orderApiService} from "../../services/otodis/OrderApiService";
import {CloudSyncOutlined, SaveOutlined} from "@ant-design/icons";
import moment from "moment";
import ServicebureauSelect from "../../components/servicebureau/ServicebureauSelect";

export interface NewTitleTransferTaxProps {

}

class NewTitleTransferTax extends Component<NewTitleTransferTaxProps & any, NewTitleTransferTaxStates> {
    private readonly initState!: NewTitleTransferTaxStates;

    constructor(props: NewTitleTransferTaxProps & any | any) {
        super(props);

        this.initState = {
            submitting: false,
            loading: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            mockData: [],
            targetKeys: [],
            supplierCode: "",
            supplierName: "",
            filterStartDate: moment().clone().startOf('month').format('YYYY-MM-DD'),
            filterEndDate: moment().clone().endOf('month').format('YYYY-MM-DD'),
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            dealerCode: data.value,
        });
    }

    onWarehouseStartDate = (data: any) => {
        this.setState({
            filterStartDate: data,
        });
    }

    onWarehouseEndDate = (data: any) => {
        this.setState({
            filterEndDate: data,
        });
    }

    onSubmit = async () => {
        await this.promisedSetState({
            submitting: true,
        });

        const input = {
            service_bureau_code: this.state.supplierCode,
            order_list: this.state.targetKeys,
        }

        try {
            await orderApiService.assignServiceBureau(
                input
            ).then(dataInsertStock => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Data berhasil diinput. code: ' + dataInsertStock.data.success.data[0].OrderCode
                });

                let newSourceData = this.state.mockData.filter(
                    (e: any) => !this.state.targetKeys.includes(e.key)
                );
                this.setState({
                    targetKeys: [],
                    mockData: newSourceData,
                    submitting: false,
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                submitting: false,
            });
        }
    }

    handleChange = (targetKeys: any) => {
        this.setState({targetKeys});
    };

    fetchOrderData = async () => {
        await this.promisedSetState({
            mockData: [],
            targetKeys: [],
        });

        const mockDataTemp: any = [];
        orderApiService.getOrder({
            dealerCode: this.state.dealerCode,
            dateStart: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            dateEnd: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
            dataType: "closing_date",
            statusOrder: "DELIVERED",
            transferTitleStatus: "NONE",
        }).then(async value => {
            for (const item of value.data.data) {
                const data = {
                    key: item.order_code,
                    title: item.order_code,
                    description: item.vehicle_engine_number + " | " + item.customer_name,
                };
                mockDataTemp.push(data);
            }
            await this.promisedSetState({
                mockData: mockDataTemp,
            });
        }).catch(async reason => {
            console.log('error');
        });
    }

    onSupplierChange = (data: any) => {
        this.setState({
            supplierCode: data.value,
            supplierName: data.children
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Dokumen`} breadcrumbMenu={`BBN Kendaraan Baru`} defaultSelectedKeys={['m-new-vehicle-bbn']} defaultOpenKeys={['sm-document']}>
                    <Row>
                        <Col xs={24} xl={12}>
                            <div className={`mid-pad-10`} style={{}}>
                                <Divider>Order Telah Dikirm</Divider><br/>
                                <Form layout={`inline`}>
                                    <Form.Item label="" className={'padTop-10'}>
                                        <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onWarehouseStartDate(event)} format={'YYYY-MM-DD'}/>
                                    </Form.Item>
                                    <Form.Item label="" className={'padTop-10'}>
                                        <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onWarehouseEndDate(event)} format={'YYYY-MM-DD'}/>
                                    </Form.Item>
                                    <Form.Item className={'padTop-10'}>
                                        <Button onClick={this.fetchOrderData} type="primary" icon={<CloudSyncOutlined/>}> Go </Button>
                                    </Form.Item>
                                </Form>
                            </div>
                        </Col>
                        <Col xs={24} xl={12}>
                            <div className={`mid-pad-10`} style={{paddingLeft: 17}}>
                                <Divider>List BBN</Divider><br/>
                                <Form.Item>
                                    <Form.Item label="" className={'padTop-10'}>
                                        <ServicebureauSelect onSupplierChangeProps={this.onSupplierChange} dealerCode={this.state.dealerCode} value={this.state.supplierCode}/>
                                    </Form.Item>
                                </Form.Item>
                            </div>
                        </Col>

                        <Col span={24}>
                            <Transfer
                                dataSource={this.state.mockData}
                                showSearch
                                listStyle={{
                                    width: '100%',
                                    height: 580,
                                }}
                                targetKeys={this.state.targetKeys}
                                onChange={this.handleChange}
                                render={item => `${item.title} | ${item.description}`}
                            />
                        </Col>

                        <Col span={24} className={`pad-10`}>
                            <Form.Item>
                                <Button type={'primary'}
                                        icon={<SaveOutlined/>}
                                        onClick={this.onSubmit}
                                        loading={this.state.submitting}>Simpan Data</Button>
                            </Form.Item>
                        </Col>

                    </Row>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(NewTitleTransferTax), 11));
